import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { routes } from './routes/routes';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme/theme';
import SnackbarWrapper from './layout/SnackbarWrapper';
import { AuthEventListener } from './contexts/AuthEventListener';
import { ProjectProvider } from './contexts/ProjectContext';
import { QueueProvider } from './contexts/QueueContext';

const router = createBrowserRouter(routes);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarWrapper>
        <AuthProvider>
          <ProjectProvider>
            <QueueProvider>
              <AuthEventListener />
              <RouterProvider router={router} />
            </QueueProvider>
          </ProjectProvider>
        </AuthProvider>
      </SnackbarWrapper>
    </ThemeProvider>
  );
}

export default App;
